import { IFlatOptionListValue } from "./option-list-value";
import OptionListValueBase from "./option-list-value-base";

export default class FlatOptionListValue extends OptionListValueBase implements IFlatOptionListValue {}

export { FlatOptionListValue };
